import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'infoIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "currentColor",
  },
  width: {
    type: Number as PropType<number>,
    default: 17,
  },
  height: {
    type: Number as PropType<number>,
    default: 16,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none"
  }, [
    _createElementVNode("path", {
      d: "M8.5 0C6.91775 0 5.37104 0.469192 4.05544 1.34824C2.73985 2.22729 1.71447 3.47672 1.10897 4.93853C0.503466 6.40034 0.34504 8.00887 0.653721 9.56072C0.962403 11.1126 1.72433 12.538 2.84315 13.6569C3.96197 14.7757 5.38743 15.5376 6.93928 15.8463C8.49113 16.155 10.0997 15.9965 11.5615 15.391C13.0233 14.7855 14.2727 13.7602 15.1518 12.4446C16.0308 11.129 16.5 9.58225 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0ZM8.66667 3.33333C8.86445 3.33333 9.05779 3.39198 9.22224 3.50186C9.38669 3.61174 9.51486 3.76792 9.59055 3.95065C9.66624 4.13338 9.68604 4.33444 9.64746 4.52842C9.60887 4.7224 9.51363 4.90059 9.37378 5.04044C9.23392 5.18029 9.05574 5.27553 8.86176 5.31412C8.66778 5.3527 8.46671 5.3329 8.28399 5.25721C8.10126 5.18153 7.94508 5.05335 7.8352 4.8889C7.72532 4.72445 7.66667 4.53111 7.66667 4.33333C7.66667 4.06812 7.77203 3.81376 7.95956 3.62623C8.1471 3.43869 8.40145 3.33333 8.66667 3.33333ZM10.1667 12.3333H7.5C7.32319 12.3333 7.15362 12.2631 7.0286 12.1381C6.90358 12.013 6.83334 11.8435 6.83334 11.6667C6.83334 11.4899 6.90358 11.3203 7.0286 11.1953C7.15362 11.0702 7.32319 11 7.5 11H8C8.04421 11 8.0866 10.9824 8.11786 10.9512C8.14911 10.9199 8.16667 10.8775 8.16667 10.8333V7.83333C8.16667 7.78913 8.14911 7.74674 8.11786 7.71548C8.0866 7.68423 8.04421 7.66667 8 7.66667H7.5C7.32319 7.66667 7.15362 7.59643 7.0286 7.4714C6.90358 7.34638 6.83334 7.17681 6.83334 7C6.83334 6.82319 6.90358 6.65362 7.0286 6.5286C7.15362 6.40357 7.32319 6.33333 7.5 6.33333H8.16667C8.52029 6.33333 8.85943 6.47381 9.10948 6.72386C9.35953 6.97391 9.5 7.31304 9.5 7.66667V10.8333C9.5 10.8775 9.51756 10.9199 9.54882 10.9512C9.58008 10.9824 9.62247 11 9.66667 11H10.1667C10.3435 11 10.5131 11.0702 10.6381 11.1953C10.7631 11.3203 10.8333 11.4899 10.8333 11.6667C10.8333 11.8435 10.7631 12.013 10.6381 12.1381C10.5131 12.2631 10.3435 12.3333 10.1667 12.3333Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})